export default function (state, type, session) {
  const { weekday, weekend } = state.vehicleUsage;
  switch (type) {
    case 'solar':
      return {
        details: state.address.parts,
        archeTypeId: state.propertyUsage,
        propertyTypeId: state.propertyId,
        hasEv: state.electricVehicleOwnership == 'Yes',
        referrerBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE
      };

    case 'ashp':
      return {
        details: state.address.parts,
        propertyTypeId: state.propertyId,
        heatingFuel: state.heatingFuel,
        referrerBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE
      };

    case 'ev':
      if (session.evOnly) {
        return {
          details: state.address.parts,
          current: state.electricVehicle,
          milesDrivenWeekDays: weekday ? Number(weekday) : 0,
          milesDrivenWeekEnds: weekend ? Number(weekend) : 0,
          chargerTypeId: state.electricVehicleChargeType || 1,
          referrerBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE
        };
      }

      return {
        details: state.address.parts,
        current: state.iceVehicle,
        compare: state.electricVehicle,
        milesDrivenWeekDays: weekday ? Number(weekday) : 0,
        milesDrivenWeekEnds: weekend ? Number(weekend) : 0,
        chargerTypeId: state.electricVehicleChargeType || 1,
        referrerBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE
      };

    default:
      return {
        details: state.address.parts,
        archeTypeId: state.propertyUsage,
        propertyTypeId: state.propertyId,
        referrerBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE
      };
  }
}
